import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import FilterPills from '../../../Components/FilterPills'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({ account, accounts, navigation, positions, position_types, categories = [], params = {} }) {
  const handleDelete = useDeleteWithConfirmation('/manage/positions')

  const handleCategoryFilterChange = (category) => {
    router.visit('/manage/positions', {
      data: { ...params, category: category || undefined },
      preserveState: true,
      preserveScroll: true
    })
  }

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div>
          <div className="font-medium text-gray-900">{value}</div>
          {item.hole_name && (
            <div className="text-sm text-gray-500">{item.hole_name}</div>
          )}
          {item.table_number && (
            <div className="text-sm text-gray-500">Table: {item.table_number}</div>
          )}
        </div>
      )
    },
    {
      key: 'category_label',
      label: 'Category',
      render: (value, item) => (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          item.category === 'IndoorPosition'
            ? 'bg-purple-100 text-purple-800'
            : 'bg-green-100 text-green-800'
        }`}>
          {value}
        </span>
      )
    },
    {
      key: 'position_type_label',
      label: 'Type',
      sortable: true
    },
    {
      key: 'qr_code',
      label: 'QR Code',
      render: (value) => (
        <code className="text-xs bg-gray-100 px-2 py-1 rounded">{value}</code>
      )
    }
  ]

  return (
    <Layout account={account} accounts={accounts} navigation={navigation} title="Locations">
      <ResourceIndexHeader
        count={positions.length}
        singular="location"
        plural="locations"
        addHref="/manage/positions/new"
        addLabel="Add Location"
      />

      <div className="mb-6">
        <FilterPills
          items={categories.map(([, value]) => value)}
          value={params.category}
          onChange={handleCategoryFilterChange}
          allLabel="All Locations"
          formatLabel={(value) => categories.find(([, v]) => v === value)?.[0] || value}
        />
      </div>

      <DataTable
        data={positions}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/positions/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search locations..."
        emptyState={{
          message: 'No locations yet',
          action: { label: 'Create your first location', href: '/manage/positions/new' }
        }}
        baseUrl="/manage/positions"
        params={params}
      />
    </Layout>
  )
}
